import { i18n } from '@/locales';
const t = i18n.t.bind(i18n);
const lc = 'views.store_management_goods_price_surcharge_infos.';
export const storeManagementGoodsPriceSurchargeInfosTableHeader = [
    {
        title: t(`${lc}table.order_amount_start`),
        align: 'end',
        sortable: false,
    },
    {
        title: t(`${lc}table.order_amount_end`),
        align: 'end',
        sortable: false,
    },
    {
        title: t(`${lc}table.surcharge`),
        align: 'end',
        sortable: false,
    },
    {
        title: t(`${lc}table.surcharge_rate`),
        align: 'end',
        sortable: false,
    },
    {
        title: t(`${lc}table.surcharge_setting`),
        align: 'center',
        width: 140,
        sortable: false,
    },
];
